module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h4', [_vm._v("Tale of the First Eunuch, Bukhayt.")]), _vm._v(" "), _c('p', [_vm._v("Know, O my brothers, that when I was a little one, some five years old, I was taken home from my native country by a slave driver who sold me to a certain Apparitor."), _c('a', {
    staticClass: "fn",
    attrs: {
      "href": "#/Text/#fns75-1"
    }
  }, [_c('sup', {
    attrs: {
      "id": "nrs75-1"
    }
  }, [_vm._v("1")])]), _vm._v(" My purchaser had a daughter three years old, with whom I was brought up; and they used to make mock of me, letting me play with her and dance for her"), _c('a', {
    staticClass: "fn",
    attrs: {
      "href": "#/Text/#fns75-2"
    }
  }, [_c('sup', {
    attrs: {
      "id": "nrs75-2"
    }
  }, [_vm._v("2")])]), _vm._v(" and sing to her, till I reached the age of twelve and she that of ten; and even then they did not forbid me seeing her. One day I went in to her and found her sitting in an inner room, and she looked as if she had just come out of the bath which was in the house; for she was scented with essences and reek of aromatic woods, and her face shone like a circle of the moon on the fourteenth night. She began to sport with me, and I with her. Now I had just reached the age of puberty; so my prickle stood at point, as it were a huge key. Then she threw me on my back and, mounting astraddle on my breast, fell a wriggling and a bucking upon me till she had uncovered my yard. When she saw it standing with head erect, she hent it in hand and began rubbing it upon the lips of her little slit"), _c('a', {
    staticClass: "fn",
    attrs: {
      "href": "#/Text/#fns75-3"
    }
  }, [_c('sup', {
    attrs: {
      "id": "nrs75-3"
    }
  }, [_vm._v("3")])]), _vm._v(" outside her petticoat trousers. Thereat hot lust stirred in me and I threw my arms round her, while she wound hers about my neck and hugged me to her with all her might, till, before I knew what I did, my pizzle split up her trousers and entered her slit and did away her maiden head. When I saw this, I ran off and took refuge with one of my comrades. Presently her mother came in to her; and, seeing her in this case, fainted clean away. However she managed the matter advisedly and hid it from the girl’s father out of good will to me; nor did they cease to call to me and coax me, till they took me from where I was. After two months had passed by, her mother married her to a young man, a barber who used to shave her papa, and portioned and fitted her out of her own monies; whilst the father knew nothing of what had passed. On the night of consummation they cut the throat of a pigeon poult and sprinkled the blood on her shift."), _c('a', {
    staticClass: "fn",
    attrs: {
      "href": "#/Text/#fns75-4"
    }
  }, [_c('sup', {
    attrs: {
      "id": "nrs75-4"
    }
  }, [_vm._v("4")])]), _vm._v(" After a while they seized me unawares and gelded me; and, when they brought her to her bridegroom, they made me her Agha,"), _c('a', {
    staticClass: "fn",
    attrs: {
      "href": "#/Text/#fns75-5"
    }
  }, [_c('sup', {
    attrs: {
      "id": "nrs75-5"
    }
  }, [_vm._v("5")])]), _vm._v(" her eunuch, to walk before her wheresoever she went, whether to the bath or to her father’s house. I abode with her a long time enjoying her beauty and loveliness by way of kissing and clipping and coupling with her,"), _c('a', {
    staticClass: "fn",
    attrs: {
      "href": "#/Text/#fns75-6"
    }
  }, [_c('sup', {
    attrs: {
      "id": "nrs75-6"
    }
  }, [_vm._v("6")])]), _vm._v(" till she died, and her husband and mother and father died also; when they seized me for the Royal Treasury as being the property of an intestate, and I found my way hither, where I became your comrade. This, then, O my brethren, is the cause of my cullions being cut off; and peace be with you! He ceased and his fellow began in these words the")]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('p', {
    attrs: {
      "id": "fns75-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#nrs75-1"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" Arab. “Jáwísh” from Turk. Cháwúsh, Chiaoosh, a sergeant, poursuivant, royal messenger. I would suggest that this is the word “Shálish” or “Jálish” in Al–Siynti’s History of the Caliphs (p. 501) translated by Carlyle “milites,” by Schultens “Sagittarius” and by Jarett “picked troops.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "fns75-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#nrs75-2"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" This familiarity with blackamoor slave-boys is common in Egypt and often ends as in the story: Egyptian blood is sufficiently mixed with negro to breed inclination for miscegenation. But here the girl was wickedly neglected by her mother at such an age as ten.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "fns75-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#nrs75-3"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" Arab. “Farj”; hence a facetious designation of the other sex is “Zawi’l-furuj” (grammatically Zawátu’l — furúj)=habentes rimam, slit ones.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "fns75-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#nrs75-4"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" This ancient and venerable practice of inspecting the marriage-sheet is still religiously preserved in most parts of the East, and in old-fashioned Moslem families. It is publicly exposed in the Harem to prove that the “domestic calamity” (the daughter) went to her husband a clean maid. Also the general idea is that no blood will impose upon the exerts, or jury of matrons, except that of a pigeon-poult which exactly resembles hymeneal blood — when not subjected to the microscope. This belief is universal in Southern Europe and I have heard of it in England. Further details will be given in Night ccxi.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "fns75-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#nrs75-5"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" “Agha” Turk.=sir, gentleman, is, I have said, politely addressed to a eunuch.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "fns75-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#nrs75-6"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" As Bukhayt tells us he lost only his testes, consequently his erectio et distensio penis was as that of a boy before puberty and it would last as long as his heart and circulation kept sound. Hence the eunuch who preserves his penis is much prized in the Zenanah where some women prefer him to the entire man, on account of his long performance of the deed of kind. Of this more in a future page.")])]), _vm._v(" "), _c('div', {
    staticClass: "section",
    attrs: {
      "id": "section76",
      "title": "Tale of the Second Eunuch, Kafur."
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5aaef08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0007.vue
// module id = 75
// module chunks = 0